import ModelUtil from '@leverege/model-util';
import { v4 } from '@leverege/base62-util';
import { FontModel } from '@leverege/ui-style-elements';
const TYPE = 'aggregation.stats.Text';
const DISPLAY_NAME = 'Stats';
const resultType = 'stats';
function create() {
  return {
    id: v4(),
    type: TYPE,
    displayName: DISPLAY_NAME,
    header: {
      label: {
        name: null,
        visible: true,
        color: null,
        font: FontModel.create()
      }
    },
    value: {
      show: {
        count: true,
        min: true,
        max: true,
        avg: true,
        sum: true
      },
      label: {
        font: FontModel.create(),
        visible: true,
        color: null,
        countValue: 'Count',
        minValue: 'Min.',
        maxValue: 'Max.',
        avgValue: 'Avg.',
        sumValue: 'Sum'
      },
      text: {
        font: FontModel.create(),
        visible: true,
        color: null,
        roundTo: 2
      }
    },
    variant: null
  };
}
export default {
  create,
  TYPE,
  DISPLAY_NAME,
  resultType,
  getDisplayName: ModelUtil.createGetValue('displayName'),
  ...ModelUtil.createAllValue('header/label/name', 'headerLabel'),
  ...ModelUtil.createAllValue('header/label/visible', 'headerLabelVisible'),
  ...ModelUtil.createAllValue('header/label/color', 'headerLabelColor'),
  ...ModelUtil.createAllValue('header/label/font', 'headerLabelFont'),
  ...ModelUtil.createAllValue('value/show/count', 'showCount'),
  ...ModelUtil.createAllValue('value/show/min', 'showMin'),
  ...ModelUtil.createAllValue('value/show/max', 'showMax'),
  ...ModelUtil.createAllValue('value/show/avg', 'showAvg'),
  ...ModelUtil.createAllValue('value/show/sum', 'showSum'),
  ...ModelUtil.createAllValue('value/label/font', 'valueLabelFont'),
  ...ModelUtil.createAllValue('value/label/visible', 'valueLabelVisible'),
  ...ModelUtil.createAllValue('value/label/color', 'valueLabelColor'),
  ...ModelUtil.createAllValue('value/label/countValue', 'countValue'),
  ...ModelUtil.createAllValue('value/label/minValue', 'minValue'),
  ...ModelUtil.createAllValue('value/label/maxValue', 'maxValue'),
  ...ModelUtil.createAllValue('value/label/avgValue', 'avgValue'),
  ...ModelUtil.createAllValue('value/label/sumValue', 'sumValue'),
  ...ModelUtil.createAllValue('value/text/font', 'valueTextFont'),
  ...ModelUtil.createAllValue('value/text/visible', 'valueTextVisible'),
  ...ModelUtil.createAllValue('value/text/color', 'valueTextColor'),
  ...ModelUtil.createAllValue('value/text/roundTo', 'roundTo'),
  ...ModelUtil.createAllValue('variant', 'variant')
};